import "react-app-polyfill/ie9";
import React from "react";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import i18n from "./Themes/Tseppas/i18n";

// Apply Martel font globally
document.body.style.fontFamily = "'Martel', 'Georgia', 'Times New Roman', serif";
document.documentElement.style.fontFamily = "'Martel', 'Georgia', 'Times New Roman', serif";

function importBuildTarget() {
    /* global process */
    if (process.env.REACT_APP_BUILD_YESHTERY === "true") {
        return import("./yeshtery/App");
    } else {
        return import("./App");
    }
}

const container = document.getElementById("root");
const root = createRoot(container);

importBuildTarget()
    .then(({ default: ImportedApp }) => {
        root.render(
            <BrowserRouter>
                <I18nextProvider i18n={i18n}>
                    <ImportedApp />
                </I18nextProvider>
            </BrowserRouter>
        );
    })
    .catch((e) => console.error("BUILD TARGET ERROR:", e));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
